/** One card of the mocked supplies surface. Its own file, as the
 *  one-component-per-file rule has it. */
import { EM_DASH, SKELETON_KEYS, cardHeading } from './supplies-mock';

export function UpcomingResuppliesCard() {
  return (
    <section className="nb-card" style={{ flex: 1, minHeight: 0 }}>
      <div className="nb-card-hd">
        <h3 className="nb-display" style={cardHeading}>
          Upcoming Resupplies
        </h3>
        <span className="nb-eyebrow">3 weeks</span>
      </div>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
        {SKELETON_KEYS.map((k) => (
          <div
            key={k}
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 10,
              padding: '7px 0',
              borderBottom: '1px dashed var(--nb-border)',
              fontSize: 11.5,
              color: 'var(--nb-subtle)',
            }}
          >
            <span style={{ width: 84, fontWeight: 700 }}>{EM_DASH}</span>
            <span style={{ flex: 1 }}>{EM_DASH}</span>
            <span className="nb-mono" style={{ fontSize: 10.5 }}>
              {EM_DASH}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
